<div *ngIf="cartDisplay" class="cart-sum-display">
  <app-box-stack
    *ngIf="cartDisplay === 'boxStack'"
    [count]="count"></app-box-stack>
  <app-box *ngIf="cartDisplay === 'box'" [count]="count"></app-box>
  <app-bag *ngIf="cartDisplay === 'bag'" [count]="count"></app-bag>
  <span class="price" *ngIf="displayPrice">€ 540,00</span>
</div>
